import { IFee } from '@rbi-ctg/menu';

import { FEE_TYPE } from './constants';

export const filterFees = (fees?: IFee[]) =>
  fees?.filter(fee => Object.keys(FEE_TYPE).includes(fee.name)) ?? [];
